'use client';

import { EcomImagePage } from '@flowx/ecom-image/client';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { Module } from '@/types/auth';

export default function Route() {
  return (
    <ProtectedRoute requiredModule={Module.ECOM_IMAGE}>
      <EcomImagePage />
    </ProtectedRoute>
  );
}
